import React, {useState} from "react";
import {Box, Button, FormControl, Stack, TextField, Typography, useTheme} from "@mui/material";
import {useParams} from "react-router-dom";
import wordCheck from "../../../functions/wordCheck";
import SuccessCheck from "../../shared/SuccessCheck";
import {useMotionValue, motion} from "framer-motion";
import { useTranslation } from 'react-i18next';

export default function WordcloudQuestion({sendAnswer, success, answered}){
    const { t } = useTranslation(['questions', 'common']);
    const [word, setWord] = useState('')
    const [spazio, setSpazio] = useState(false)

    let progress = useMotionValue(90)

    const handleSetWord = (event) => {
      setWord(event.target.value)
    }

    function capitalizeTheFirstLetterOfEachWord(words) {
        var separateWord = words.toLowerCase().split(' ');
        for (var i = 0; i < separateWord.length; i++) {
            separateWord[i] = separateWord[i].charAt(0).toUpperCase() +
                separateWord[i].substring(1);
        }
        return separateWord.join(' ');
    }

    const handleSendAnswer = () => {
        let w = capitalizeTheFirstLetterOfEachWord(word).trim()
        const wordCount = w.split(/\s+/).filter(Boolean).length;

        setSpazio(false)
        if (wordCount > 3) {
            console.info('Boh?')
            setSpazio(true);
        } else {
            if(wordCheck(w)) {
                console.info('mandando le parole')
                sendAnswer(w);
                setWord('');
            } else {
                console.info('Boh?')
                setWord('');
            }
        }

    }

    return(
        <Stack sx={{position:'relative'}} justifyContent={"start"} alignItems={"start"} style={{textAlign:'center', height:'100%'}} spacing={5}>
            {(!success) && <Box sx={{width: '100%', mt:5}}>
                <FormControl variant="standard" style={{width: '100%'}}>
                    <TextField
                        placeholder={t('wordcloud.enterWord')}
                        id="component-simple"
                        value={word}
                        onChange={handleSetWord}/>
                </FormControl>
                {word && word.trim().split(/\s+/).length > 3 &&
                    <Typography sx={{mt: 1}}>{t('wordcloud.maxWords')}</Typography>
                }
                <Button disabled={word.trim().split(/\s+/).length > 3 || word.trim().length < 2} sx={{mt: 4}} variant={'default'} onClick={handleSendAnswer}>{t('common:send')}</Button>
            </Box>}
            {(success || answered) &&
                <Box style={{width:'100%'}}>
                    <motion.div
                        initial={{ x: 0 }}
                        animate={{ x: 100 }}
                        style={{ x: progress }}
                        transition={{ duration: 0.8 }}
                    />
                    <SuccessCheck progress={progress}/>
                </Box>
            }
        </Stack>
    )
}
